import React from 'react';

import * as S from './style';
import * as T from '../../components/Typography';
import { SectionLayout } from '../../components/Layouts';
import { Row, Col } from '../../components/Grid';

export const FAQLinksMobile = ({ ...props }) => {
  return (
    <S.MobileWrapper>
      <SectionLayout bgcolor="gray2">
        <Row>
          <Col w={[4, 4, 4]}>
            <S.Wrapper {...props}>
              <T.P16Bold color="midnight">On this page:</T.P16Bold>
              <S.List>
                <li>
                  <T.Link16 to="/FAQs#how-it-works" color="blue">
                    How Tempo Time Credits work
                  </T.Link16>
                </li>
                <li>
                  <T.Link16 to="/FAQs#get-involved" color="blue">
                    Who can get involved?
                  </T.Link16>
                </li>
                <li>
                  <T.Link16 to="/FAQs#how-earn-tc" color="blue">
                    How do people earn Tempo Time Credits?
                  </T.Link16>
                </li>
                <li>
                  <T.Link16 to="/FAQs#how-spend-tc" color="blue">
                    How do people spend Tempo Time Credits?
                  </T.Link16>
                </li>
                <li>
                  <T.Link16 to="/FAQs#tc-benefits" color="blue">
                    Do Time Credits affect benefits?
                  </T.Link16>
                </li>
              </S.List>
            </S.Wrapper>
          </Col>
        </Row>
      </SectionLayout>
    </S.MobileWrapper>
  );
};

export const AboutLinksMobile = ({ ...props }) => {
  return (
    <S.MobileWrapper>
      <SectionLayout bgcolor="gray2">
        <Row>
          <Col w={[4, 4, 4]}>
            <S.Wrapper {...props}>
              <T.P16Bold color="midnight">On this page:</T.P16Bold>
              <S.List>
                <li>
                  <T.Link16 to="/about-us#our-vision" color="blue">
                    Our vision
                  </T.Link16>
                </li>
                <li>
                  <T.Link16 to="/about-us#our-mission" color="blue">
                    Our mission
                  </T.Link16>
                </li>
                <li>
                  <T.Link16 to="/about-us#our-values" color="blue">
                    Our values
                  </T.Link16>
                </li>
                <li>
                  <T.Link16 to="/about-us#our-people" color="blue">
                    Our people
                  </T.Link16>
                </li>
                <li>
                  <T.Link16 to="/about-us#join-tempo" color="blue">
                    Join Tempo
                  </T.Link16>
                </li>
              </S.List>
            </S.Wrapper>
          </Col>
        </Row>
      </SectionLayout>
    </S.MobileWrapper>
  );
};
